// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__3hYBt","actions":"Section_actions__3W_Of","count":"Section_count__wYVyw","name":"Section_name__2pfSX"};